import type { ExtractionResult, Need } from "@larder/shared";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";
import { app, usingEmulators } from "../firebase";

/**
 * Client side of label extraction.
 *
 * The app never holds an API key and never talks to Anthropic. It posts a frame
 * to a callable function, which is the only place the credential exists
 * (AGENTS.md rule 4). That also means the model, the prompt and the validation
 * layer can all change without shipping a new PWA.
 */

export const functions = getFunctions(app, "asia-south1");

if (usingEmulators) {
  // Vite HMR can re-run this module; connecting twice throws.
  const g = globalThis as { __larderFunctions?: boolean };
  if (!g.__larderFunctions) {
    g.__larderFunctions = true;
    // Host derived from the page, so a phone on the LAN reaches it too.
    connectFunctionsEmulator(functions, window.location.hostname, 5001);
  }
}

const call = httpsCallable<
  { imageBase64: string; need: Need; context: unknown; timezone: string },
  ExtractionResult
>(functions, "extractLabel", { timeout: 60_000 });

export async function extractLabel(
  imageBase64: string,
  need: Need,
  context: unknown,
  timezone: string,
): Promise<ExtractionResult> {
  // The timezone decides which DAY the scan counts against; a quota that reset
  // at 05:30 local would be baffling.
  const res = await call({ imageBase64, need, context, timezone });
  return res.data;
}
